module.exports = __webpack_public_path__ + "static/marc-stein-4a04f91d57aad61ab8b3655d90363075.jpg";